import React from 'react'
import './EditCompositionList.css'

const CompositionContainers=({props})=>{
    return(
        props.compositionContainers.map(container=>{
       
            return(                 
                <div className={container.conID === props.editingCompositionID? "selectedRowArea":"rowArea"}  onDoubleClick={()=>{props.changeSelectedTab(2)}} onClick={()=>{props.getEditingCompositionID(container.conID)}}  onContextMenu={(e)=>{
                    e.preventDefault()
                    e.stopPropagation()
                    let refPos={
                        x:e.clientX,
                        y:e.clientY
                    }
                    let msg = {
                        conID:container.conID,
                        pos:refPos
                    }
                    props.getContextMenu(msg)
                }}>
                    <div className={"rowCell"} >{container.conID}</div>
                    <div className={"rowCell"} >{container.type}</div>
                    <div className={"rowCell"} >{container.title}</div>          
                </div>      
            )
        })
    )
}
  
export default function EditCompositionList(props) {
 
    const selectEditContainerArea = {
        display: 'flex',
        flexDirection: 'column',
        borderBottom:"1px solid black",
        fontFamily: "Microsoft JhengHei",
    }

    const rowArea = {
        display: 'flex',
    }

    const columnHeader = {
        width:"50%",
        border:"1px solid black",
        fontFamily: "Microsoft JhengHei",
    }

    
    return (
        
        <div style={selectEditContainerArea}> 
            <div>區塊列表</div>
            <div style={rowArea}>
                <div style={columnHeader}>區塊ID</div>
                <div style={columnHeader}>區塊種類</div>
                <div style={columnHeader}>區塊名稱</div>           
            </div> 
            <CompositionContainers props={props}/>
        </div> 
    )
}